import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Logo, useSettings } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const settings = useSettings();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.post("/auth/password-token/check", { token }).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e, "Link non valido o scaduto.")));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) return setError("Le due password non coincidono");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/set-password", { token, new_password: pwd });
      toast.success("Password impostata: ora puoi accedere");
      navigate("/login", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-5">
      <form onSubmit={submit} className="card-surface w-full max-w-md p-8 fade-up" data-testid="set-password-form">
        <div className="mb-6 flex items-center gap-2">
          <Logo settings={settings} className="h-10 w-10" />
          <div className="leading-tight"><div className="font-display font-bold text-[#0F2042]">Passrace</div><div className="text-[10px] font-semibold uppercase tracking-widest text-amber-600">Registro Nazionale MSP Italia</div></div>
        </div>
        <h1 className="font-display text-2xl font-bold text-slate-900">Imposta la tua password</h1>
        {!info && !error && <div className="mt-6 flex items-center gap-2 text-slate-500"><Loader2 className="h-4 w-4 animate-spin" />Verifica del link…</div>}
        {info && (
          <>
            <p className="mt-2 text-sm text-slate-600">Account: <b data-testid="set-password-email">{info.email}</b></p>
            <div className="mt-6 space-y-4">
              <Input type="password" required minLength={8} placeholder="Nuova password (min. 8 caratteri)" value={pwd} onChange={(e) => setPwd(e.target.value)} className="h-11" data-testid="set-password-input" />
              <Input type="password" required minLength={8} placeholder="Ripeti la password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} className="h-11" data-testid="set-password-confirm-input" />
              <Button type="submit" disabled={busy} className="h-11 w-full bg-[#0F2042] hover:bg-[#1E3A8A]" data-testid="set-password-submit-btn">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><KeyRound className="mr-2 h-4 w-4" />Salva password</>}
              </Button>
            </div>
          </>
        )}
        {error && <div className="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800" data-testid="set-password-error">{error}</div>}
        <Link to="/login" className="mt-6 inline-block text-sm text-slate-500 hover:text-slate-900" data-testid="set-password-login-link">Vai all'accesso</Link>
      </form>
    </div>
  );
}
